module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Tulip-Fever.dbc0d53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Tulip-Fever.jpg
// module id = avD9
// module chunks = 0